import { useQuery } from "@tanstack/react-query";
import { userPreferencesService } from "./userPreferencesService";

export const useUserPreferencesQuery = () => {
	const { data, isLoading } = useQuery({
		queryKey: userPreferencesService.showKey,
		queryFn: () => userPreferencesService.show().then((r) => r.data.data),
	});

	return {
		userPreferences: data,
		isLoading,
	};
};
